export default __webpack_public_path__ + "static/media/NORLYSText-Bold.f7d7f3a7.woff";